<template>
  <div>
    <v-list
      class="document-list mt-4"
      shaped
    >
      <v-list-item
        v-for="(document, index) in documents"
        :key="index"
        class="grey lighten-4"
      >
        <v-list-item-icon>
          <v-icon>mdi-file-document</v-icon>
        </v-list-item-icon>
        <v-list-item-content v-text="document.name" />
        <v-list-item-action>
          <v-btn
            icon
            @click="removeOption(index)"
          >
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <div class="d-flex">
      <v-btn
        color="primary"
        class="mr-2"
        small
        outlined
        @click="openNewDocumentDialog"
      >
        <v-icon left>
          mdi-plus
        </v-icon>New
      </v-btn>
      <v-btn
        color="primary"
        small
        outlined
        @click="openExistingDocumentDialog"
      >
        <v-icon left>
          mdi-plus
        </v-icon>Existing
      </v-btn>
    </div>

    <v-dialog
      v-model="addDialog"
      attach=".EditFormSectionComponent"
      max-width="500px"
    >
      <v-sheet class="pa-4 d-flex">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="newFile.name"
              label="Name"
              placeholder="document name"
              @click="resetErrorMessage"
            />
          </v-col>
          <v-col cols="12">
            <v-file-input
              v-model="newFile.file"
              label="File upload"
              placeholder="Select your file..."
              @click="resetErrorMessage"
            >
              <template
                v-slot:append-outer
                class="mt-0"
              >
                <v-btn
                  class=""
                  color="primary"
                  :disabled="newFile.file===undefined"
                  fab
                  @click="addNewDocument"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-file-input>
            <div
              class="error--text"
              style="font-size:12px; font-weight: bold;"
            >
              {{ errors }}
            </div>
          </v-col>
        </v-row>
      </v-sheet>
    </v-dialog>

    <v-dialog
      v-model="existingDialog"
      attach=".EditFormSectionComponent"
      max-width="500px"
    >
      <v-sheet class="pa-4 d-flex">
        <v-autocomplete
          v-model="search"
          label="Search for an existing document"
          :items="items"
          item-text="name"
          item-value="name"
          return-object
        />
        <v-spacer />
        <v-btn
          class="mt-2"
          color="primary"
          :disabled="search===''"
          fab
          @click="addExistingDocument"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    documents: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    search: '',
    newFile: {
      name: '',
      file: undefined
    },
    addDialog: false,
    existingDialog: false,
    documentCopy: [],
    errors: null
  }),
  computed: {
    items () {
      return this.$store.state.documents.agencyDocuments
    }
  },
  created () {
    this.documentCopy = _.cloneDeep(this.documents)
  },
  methods: {
    openNewDocumentDialog () {
      this.addDialog = true
      this.resetErrorMessage()
    },
    resetErrorMessage () {
      this.errors = null
    },
    addNewDocument () {
      this.resetErrorMessage()
      const self = this
      const formData = new FormData()
      formData.append('name', self.newFile.name === '' ? self.newFile.file.name : self.newFile.name)
      formData.append('category_id', 'cfdc77b5-827b-4494-8c6c-c99a36b40abf')
      formData.append('category', 'Agency')
      formData.append('documentable_id', self.$store.state.agencies.agency.id)
      formData.append('documentable_type', 'App\\Agency')
      formData.append('file', self.newFile.file)
      formData.append('public', true)
      axios.post(self.URLs.core.documents.root, formData).then(response => {
        self.documents.push({
          id: response.data.id,
          name: self.newFile.name === '' ? self.newFile.file.name : self.newFile.name
        })
        self.addDialog = false
        self.newFile = { name: '', file: undefined }
        self.$store.dispatch('documents/setAgencyDocuments')
        self.$emit('newDocument', this.documents)
      }).catch(error => {
        const largeFileStatusCode = 413
        const invalidFileStatusCode = 422
        if (error.response.status === invalidFileStatusCode &&
              error.response.data.errors.file[0]) {
          self.errors = 'Error: ' + error.response.data.errors.file[0]
        } else if (error.response.status === largeFileStatusCode) {
          self.errors = 'Error: Request Entity Too Large'
        } else if (!(typeof error.message === 'undefined')) {
          self.errors = 'Error: ' + error.message
        } else {
          self.errors = 'Error: failed to upload a document.'
        }
      })
    },
    openExistingDocumentDialog () {
      this.existingDialog = true
    },
    addExistingDocument () {
      this.documents.push(this.search)
      try {
        axios.post('/api/documents/publicise', this.search)
      } catch (error) {
        console.log(error)
      }
      this.existingDialog = false
      this.search = ''
      this.$emit('newDocument', this.documents)
    },
    removeOption (index) {
      this.documents.splice(index, 1)
    }
  }
}
</script>
<style lang='scss'>

</style>
